import {
  Avatar,
  Chip,
  Divider,
  Fade,
  Grid,
  Box,
  ImageList,
  ImageListItem,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  Radio,
  FormControlLabel,
  FormControl,
  RadioGroup,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format, formatDistance, parse } from "date-fns";
import { useRef, useState, useEffect, useCallback } from "react";
import { theme } from "../../theme";
import ImageViewer from "./ImageShower";
import AudioPlayer from "react-h5-audio-player";
import FileItem from "./FileItem";
import "react-h5-audio-player/lib/styles.css";
import Api from "../../ajax";
import IconButton from "@mui/material/IconButton";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import StarBorder from "@mui/icons-material/StarBorder";
import Star from "@mui/icons-material/Star";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ReactPlayer from "react-player";
import "../Common.css";
import "./PostAnimation.css";
import "./PostItem.css";
import PostTranslate from "../common/PostTranslate";
import ShareButton from "../common/Sharebutton";
import { read } from "xlsx";
import FileGalleryPreview from "../activity/FileGalleryPreview";


const api = new Api();

const PostItem = (props) => {
  const [postDetails, setPostDetails] = useState(props.data);

  useEffect(() => {
    setPostDetails(props.data);
  }, [props.data]);

  // Sync local interaction state when a different post is supplied (e.g. force post carousel)
  useEffect(() => {
    setRFlag(postDetails.read_flag);
    setLike(postDetails.is_like);
    setStarred(postDetails.post_flag);
    setAcknowledged(postDetails.is_ack);
    setSelectedOption(postDetails.ans_choice);
  }, [postDetails.post_receiver_id, postDetails.id_hash]);

  const {
    post_title,
    post_content,
    post_type,
    timeline,
    receivers_label,
    receivers_list,
    cat_name,
    sender_scode,
    sender_name,
    sender_sclr,
    media,
    id,
    id_hash,
    post_receiver_id,
    read_flag,
    cat_flag,
    bg_color,
    txt_color,
    post_for,
    is_like,
    is_ack,
    ack_req,
    post_flag,
    template_url,
    link_json,
    post_survey_ans_id,
    post_survey_id,
    have_survey,
    survey_question,
    option_a,
    option_b,
    option_c,
    option_d,
    ans_choice,
    post_translate,
    header_footer,
  } = postDetails;


  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [viewerImages, setViewerImages] = useState([]);
  const [expandReceiver, setExpandReceiver] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [readFlag, setRFlag] = useState(read_flag);
  const [islike, setLike] = useState(is_like);
  const [isstar, setStarred] = useState(post_flag);
  const [acknowledged, setAcknowledged] = useState(is_ack);
  const open = Boolean(anchorEl);
  const postItemRef = useRef();
  const videoPlayerRef = useRef();
  const audioPlayerRef = useRef();
  const displaybutton = props.showbutton;
  const showshare = props.showshare;
  const [selectedOption, setSelectedOption] = useState(ans_choice);
  //const [showTranslateBt, setShowTranslateBt] = useState(true);
  const [showCatFlag, setShowCatFlag] = useState(false);
  const [playingId, setPlayingId] = useState(null);

  const pauseAudio = useCallback(() => {
    if (
      audioPlayerRef !== undefined &&
      audioPlayerRef !== null &&
      audioPlayerRef.current !== undefined &&
      audioPlayerRef.current !== null &&
      audioPlayerRef.current.audio !== undefined &&
      audioPlayerRef.current.audio !== null
    ) {
      if (
        audioPlayerRef.current.audio.current !== undefined &&
        audioPlayerRef.current.audio.current !== null
      ) {
        if (!audioPlayerRef.current.audio.current.paused) {
          audioPlayerRef.current.audio.current.pause();
        }
      }
    }
  }, []);

  const pauseVideo = useCallback(() => {
    if (
      videoPlayerRef !== undefined &&
      videoPlayerRef !== null &&
      videoPlayerRef.current !== undefined &&
      videoPlayerRef.current !== null &&
      (document.pictureInPictureElement === null ||
        document.pictureInPictureEnabled === false)
    ) {
      if (!videoPlayerRef.current.paused) {
        videoPlayerRef.current.pause();
      }
    }
  }, [videoPlayerRef]);

  useEffect(() => {
    if (post_type === "V" || post_type === "C") {
      if (props.scrollEvent !== undefined && props.scrollEvent !== null) {
        if (
          !(
            props.parentRef.el.scrollTop + props.parentRef.el.clientHeight >=
            postItemRef.current.offsetTop
          ) ||
          props.parentRef.el.scrollTop +
          props.parentRef.el.clientHeight -
          postItemRef.current.scrollHeight >=
          postItemRef.current.offsetTop + postItemRef.current.scrollHeight
        ) {
          pauseVideo();
        }
      }
    } else if (post_type === "A" || post_type === "U") {
      if (
        props.scrollEvent !== undefined &&
        props.scrollEvent !== null &&
        props.parentRef != null
      ) {
        if (
          !(
            props.parentRef.el.scrollTop + props.parentRef.el.clientHeight >=
            postItemRef.current.offsetTop
          ) ||
          props.parentRef.el.scrollTop +
          props.parentRef.el.clientHeight -
          postItemRef.current.scrollHeight >=
          postItemRef.current.offsetTop + postItemRef.current.scrollHeight
        ) {
          pauseAudio();
        }
      }
    }
    return () => { };
  }, [
    post_type,
    props.scrollEvent,
    props.parentRef,
    postItemRef,
    pauseAudio,
    pauseVideo,
  ]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const deletePost = () => {
    setAnchorEl(null);
    props.requestDelete(id);
  };

  const onVidContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  const openGallery = (media, index) => {
    const selectedFile = media[index];
    if (
      selectedFile.mime_type?.startsWith("image/") ||
      /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(
        selectedFile.surl || selectedFile.turl || selectedFile.url
      )
    ) {
      setViewerImages(media);
      setCurrentIndex(index);
      setViewerOpen(true);
    }
  };

  function onRead(read_flag, id) {
    if (read_flag !== "R") {
      api.post("/posts/read-recipet", { post_receiver_id: id }, (res) => {
        if (props.callfrom === "force") {
          try {
            if (post_receiver_id && typeof props.addRead === "function") {
              props.addRead(post_receiver_id);
              setRFlag("R");
            }
          } catch (e) {
          }
          return;
        }
        if (res.s && res.d) {
          setRFlag("R");
          props.addRead && props.addRead(postDetails.id);
        }
      });
      // Wait 5 seconds before showing animation
      setTimeout(() => {
        if (cat_flag === "BD") {
          setShowCatFlag(true);

          // Hide it after 5 seconds 
          setTimeout(() => {
            setShowCatFlag(false);
          }, 5000); // 5 seconds
        }
      }, 1000);
    }
  }

  function toggleAcknowledgment(is_like, id) {
    if (is_ack !== "Y") {
      api.post("/posts/ack-recipet", { post_receiver_id: id }, (res) => {
        if (res.s && res.d) {
          setAcknowledged("Y");
          //props.addRead();
        }
      });
    }
  }

  function toggleLike(is_like, id) {
    if (is_like !== "L") {
      api.post("/posts/like-recipet", { post_receiver_id: id }, (res) => {
        if (res.s && res.d) {
          setLike("L");
          //props.addRead();
        }
      });
    }
  }
  function toggleStarred(is_star, id) {
    let post_star = "";
    if (is_star !== "S") {
      setStarred("S");
      post_star = "S";
    } else {
      setStarred("N");
      post_star = "N";
    }
    api.post(
      "/posts/star-post",
      { post_receiver_id: id, post_flag: post_star },
      (res) => {
        if (res.s && res.d) {
          //props.addRead();
        }
      }
    );
  }
  const copyToClipboard = () => {
    var divContainer = document.createElement("div");
    divContainer.innerHTML = post_content;
    let content = divContainer.textContent || divContainer.innerText || "";
    navigator.clipboard.writeText(post_title + "\n" + content);
  };

  const transparentStyle = {
    //backgroundColor: 'transparent',
    //border: '1px solid #ccc',
    padding: "0",
    margin: "0",
    borderRadius: "5px",
    position: "relative",
  };

  const normalStyle = {
    padding: "0",
    margin: "0",
    borderRadius: "5px",
    position: "relative",
  };
  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(35, 93, 153, 0.9)",
    zIndex: 2,
    display: readFlag === "N" ? "block" : "none",
    cursor: "pointer",
    textAlign: "center",
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    api.post(
      "/posts/survey",
      {
        post_survey_ans_id: post_survey_ans_id,
        ans_choice: event.target.value,
        post_survey_id: post_survey_id,
      },
      (res) => { }
    );
  };

  const institueID = localStorage.getItem("inst_id");
  const [translatedLang, setTranslatedLang] = useState("");

  const onTranslate = (activeLang, translatedData) => {
    setPostDetails((prevState) => ({
      ...prevState,
      post_translate: { ...prevState.post_translate, ...translatedData },
    }));

    setTranslatedLang(activeLang);
  };

  const handleClick = async (data) => {
    const activeLang = translatedLang !== data.code ? data.code : "";

    if (activeLang && (!post_translate || !post_translate[activeLang])) {
      api.post(
        "/posts/translate",
        {
          post_id: id_hash,
          lang_id: data.id,
          lang_name: data.label,
          lang_code: data.code,
        },
        (res) => {
          onTranslate(activeLang, { [data.code]: res.d });
        }
      );
    } else {
      setTranslatedLang(activeLang);
    }
  };


  return (
    <Grid
      ref={postItemRef}
      container
      sx={{
        backgroundColor: "#FFF",
        borderRadius: "4px",
        border: "1px solid #DDD",
        padding: "8px 8px 0 8px",
        //height: "280px",
        fontSize: "15px",
        fontWeight: 600,
        marginBottom: "8px !important",
      }} className="neomorpism_border active"
    >
      <Stack sx={{ width: "100%", height: "100%" }} spacing={1}
        divider={<Divider flexItem style={{ marginBottom: "8px" }} />}
      >
        <div style={readFlag === "N" ? transparentStyle : normalStyle}>
          <div
            style={overlayStyle}
            onClick={() => onRead(readFlag, post_receiver_id)}
          >
            <div
              style={{
                fontSize: "16px",
                color: "#fff",
                position: "relative",
                top: "45%",
                left: "50%",
                transform: " translate(-50%,-50%)",
              }}
            >
              <div>
                <TouchAppIcon sx={{ fontSize: "48px" }} />
              </div>
              Click Here To Read
            </div>

          </div>
          <Stack direction="row" sx={{ position: "relative", }}>
            <Tooltip title={sender_name} arrow>
              <Avatar variant="rounded" sx={{ backgroundColor: sender_sclr }}>
                <Typography>{sender_scode.toUpperCase()}</Typography>
              </Avatar>
            </Tooltip>

            <Stack
              sx={{
                ml: "8px",
                cursor: readFlag === "R" ? "default" : "pointer",
              }}
            >
              <div
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  width: "inherit",
                  fontWeight: readFlag === "R" ? "400" : "700",
                }}
              >
                {cat_name}
              </div>
              <Stack direction="row" spacing={1}>
                {post_for === "C" && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: theme.palette.secondary.main,
                      cursor: receivers_list.length > 0 ? "pointer" : "default",
                    }}
                    onClick={() => {
                      if (receivers_list.length > 0)
                        setExpandReceiver(!expandReceiver);
                    }}
                  >
                    {receivers_label}
                  </div>
                )}
                <div style={{ fontSize: "12px", color: "#AAA" }}>
                  <div>
                    {format(
                      parse(timeline, "yyyy-MM-dd H:mm:ss", new Date()),
                      "dd MMM yyyy, hh:mm aaa"
                    )}
                  </div>
                </div>
              </Stack>
              {expandReceiver && receivers_list.length > 0 && (
                <Fade in={expandReceiver}>
                  <Grid
                    container
                    sx={{
                      mt: 1,
                      borderRadius: "4px",
                      backgroundColor: "#EEE",
                      p: 1,
                    }}
                    columnGap={1}
                    rowGap={1}
                  >
                    {receivers_list.map((receiver) => {
                      return (
                        <Chip key={receiver} label={receiver} size="small" />
                      );
                    })}
                  </Grid>
                </Fade>
              )}
            </Stack>
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                px: 1,
                py: 0.5,
                zIndex: 1,
              }}
            >
              <Grid item>
                <Tooltip title="Copy to Clipboard" arrow>
                  <IconButton
                    color="primary"
                    size="small"
                    id={"post-menu-button" + id}
                    aria-controls={open ? "post-menu" + id : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={copyToClipboard}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </IconButton>
                </Tooltip>

                <Menu
                  id={"post-menu" + id}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  MenuListProps={{
                    "aria-labelledby": "post-menu-button" + id,
                  }}
                  sx={{ "& ul": { p: 0 } }}
                >
                  <MenuItem onClick={deletePost} dense>
                    Delete
                  </MenuItem>
                </Menu>
              </Grid>
              {showshare && (
                <Grid item>
                  <ShareButton
                    sharetitle={post_title}
                    sharetext={post_content}
                    sharemedia={media}
                    screenshotRef={postItemRef}
                  />
                </Grid>
              )}
            </Grid>

          </Stack>
          <div style={{ border: "1px solid #ddd", marginTop: "8px", marginBottom: "8px" }}>
          </div>


          {showCatFlag && (
            <div
              className="post_birth_anim"
              style={{
                background: 'url("/images/post-images/birth_1.gif")',
                position: 'absolute',
                top: '0',
                left: '0',
                height: '100%',
                width: '100%',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: '1'
              }}
            ></div>
          )}

          {/* <div class="post_birth_anim" style={{ background: 'url("/images/post-images/birth_3.gif")', position: 'absolute', top: '0', left: '0', height: '100%', width: '100%', backgroundSize: 'cover', backgroundPosition: 'center', zIndex: '1' }}>
          </div> */}


          <Stack
            style={{
              backgroundRepeat: "no-repeat",
              fontSize: "18px",
              backgroundPosition: "center",
              width: "100%",
              height: "100%",
              color: txt_color !== "000000" ? txt_color : "#",
            }}
          >
            <Stack>
              <Stack
                style={{
                  backgroundRepeat: "no-repeat",
                  fontSize: "18px",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "100%",
                  color: txt_color !== "000000" ? txt_color : "#000000",
                }}
              >
                {post_type !== "L" && (
                  <Stack>
                    {/* Header */}
                    {header_footer === "Y" &&
                      props.callfrom === "P" &&
                      props.schoollist?.post_header_url && (
                        <img
                          alt="Header Logo"
                          src={props.schoollist.post_header_url}
                          style={{
                            maxHeight: "140px",
                            width: "100%",
                            objectFit: "cover",
                            display: "block",
                            margin: 0,
                            padding: 0,
                          }}
                          onError={(e) => {
                            console.error("Failed to load header image:", props.schoollist.post_header_url);
                            e.target.style.display = "none";
                          }}
                        />
                      )}

                    {/* Conditional Content: Media or Text */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: "900px",
                        margin: "0 auto",
                      }}
                    >
                      {/* Render Media Layout if attachments are present */}
                      {media && media.length > 0 && (
                        <Box sx={{ width: "100%" }}>
                          <Grid container columnGap={2} sx={{ justifyContent: "center" }}>
                            <FileGalleryPreview
                              files={media}
                              playingId={playingId}
                              setPlayingId={setPlayingId}
                              onImageClick={openGallery}
                            />
                            <ImageViewer
                              images={viewerImages}
                              open={viewerOpen}
                              onClose={() => setViewerOpen(false)}
                              initialIndex={currentIndex}
                            />
                          </Grid>

                          {/* Post Title */}
                          <div className="main_post_title" style={{ marginTop: 0 }}>
                            {!translatedLang
                              ? post_title
                              : post_translate[translatedLang].title}
                          </div>

                          {/* Post Content */}
                          <div
                            className="main_post_content"
                            style={{ marginTop: 0 }}
                            dangerouslySetInnerHTML={{
                              __html: !translatedLang
                                ? post_content
                                : post_translate[translatedLang].message,
                            }}
                          ></div>
                        </Box>
                      )}

                      {/* Render Text-Only Layout if no attachments and text exists */}
                      {!(media && media.length > 0) && (post_content || post_title) && (
                        <Box sx={{ width: "100%" }}>
                          <div
                            style={{
                              backgroundImage: template_url ? `url(${template_url})` : "none",
                              backgroundColor: template_url ? "transparent" : bg_color,
                              backgroundSize: "cover",
                              whiteSpace: "pre-wrap",
                              textAlign: "center",
                              padding: "20px",
                              borderRadius: "8px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                            className="post_content_box"
                          >
                            {/* Post Content with Title at Top */}
                            {post_content !== "" && (
                              <div
                                style={{
                                  backgroundImage: template_url
                                    ? `url(${template_url})`
                                    : "none",
                                  backgroundColor: template_url
                                    ? "transparent"
                                    : bg_color,
                                  backgroundSize: "cover",
                                  whiteSpace: "pre-wrap",
                                  textAlign: "center",
                                  padding: "10px",
                                }}
                                className="post_content_box"
                              >
                                {/* Post Title */}
                                <div
                                  className="text_post_title"
                                >
                                  {!translatedLang
                                    ? post_title
                                    : post_translate[translatedLang].title}
                                </div>

                                {/* Post Message */}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: !translatedLang
                                      ? post_content
                                      : post_translate[translatedLang].message,
                                  }}
                                  style={{ textAlign: "justify" }}
                                  className="text_post_content"
                                ></div>
                              </div>
                            )}
                          </div>
                        </Box>
                      )}
                    </Box>

                    {/* Footer */}
                    {header_footer === "Y" &&
                      props.callfrom === "P" &&
                      props.schoollist?.post_footer_url && (
                        <Box
                          sx={{
                            boxSizing: "border-box",
                            width: "100%",
                            padding: "0",
                            textAlign: "center",
                            fontSize: { xs: "11px", md: "14px" },
                            borderBottom: "1px solid #0000001f",
                          }}
                        >
                          <img
                            alt="Footer Logo"
                            src={props.schoollist.post_footer_url}
                            style={{
                              maxHeight: "140px",
                              width: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              console.error("Failed to load footer image:", props.schoollist.post_footer_url);
                              e.target.style.display = "none";
                            }}
                          />
                        </Box>
                      )}
                  </Stack>
                )}
              </Stack>
              {post_type === "L" && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    p: 0,
                    m: 0,
                  }}
                >
                  {/* Header */}
                  {header_footer === "Y" &&
                    props.callfrom === "P" &&
                    props.schoollist?.post_header_url && (
                      <Box
                        sx={{
                          display: "flex",
                          minHeight: "100px",
                          alignItems: "center",
                          width: "100%",
                          p: 0,
                          m: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            p: 0,
                            m: 0,
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: { xs: "15px", md: "20px", lg: "22px" },
                              fontWeight: "bold",
                              color: "#000",
                              width: "100%",
                            }}
                          >
                            <img
                              alt="Header Logo"
                              src={props.schoollist.post_header_url}
                              style={{
                                maxHeight: "140px",
                                width: "100%",
                                objectFit: "cover",
                                marginBottom: 0,
                                display: "block",
                              }}
                              onError={(e) => {
                                console.error(
                                  "Failed to load header image:",
                                  props.schoollist.post_header_url
                                );
                                e.target.style.display = "none";
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    )}

                  {/* Video */}
                  <Box sx={{ m: 0, p: 0 }}>
                    <ReactPlayer
                      url={link_json}
                      loop={false}
                      playing={false}
                      controls={true}
                      pip={true}
                      className="player_link"
                      style={{ margin: 0 }}
                    />
                  </Box>

                  {/* Post Title */}
                  <div className="main_post_title" style={{ marginTop: 0 }}>
                    {!translatedLang
                      ? post_title
                      : post_translate[translatedLang].title}
                  </div>

                  {/* Post Content */}
                  <div
                    className="main_post_content"
                    style={{ marginTop: 0 }}
                    dangerouslySetInnerHTML={{
                      __html: !translatedLang
                        ? post_content
                        : post_translate[translatedLang].message,
                    }}
                  ></div>

                  {/* Footer */}
                  {header_footer === "Y" &&
                    props.callfrom === "P" &&
                    props.schoollist?.post_footer_url && (
                      <Box
                        sx={{
                          boxSizing: "border-box",
                          width: "100%",
                          padding: 0,
                          textAlign: "center",
                          fontSize: { xs: "11px", md: "14px" },
                          borderBottom: "1px solid #0000001f",
                          marginTop: 0,
                        }}
                      >
                        <img
                          alt="Footer Logo"
                          src={props.schoollist.post_footer_url}
                          style={{
                            maxHeight: "140px",
                            width: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                          onError={(e) => {
                            console.error(
                              "Failed to load footer image:",
                              props.schoollist.post_footer_url
                            );
                            e.target.style.display = "none";
                          }}
                        />
                      </Box>
                    )}
                </Box>
              )}
            </Stack>
          </Stack>
          {have_survey === "Y" && (
            <Stack spacing={2} style={{ paddingTop: "0", marginTop: "0" }}>
              <div className="main_post_sub_title">
                <h4 style={{ marginTop: "10px", marginBottom: "0" }}>
                  Q. {survey_question}
                </h4>
                <div
                  style={{
                    textAlign: "left",
                    display: "inline-block",
                    marginLeft: "50px",
                  }}
                >
                  {selectedOption ? (
                    <p>
                      {selectedOption === "a" && `A. ${option_a}`}
                      {selectedOption === "b" && `B. ${option_b}`}
                      {selectedOption === "c" && option_c && `C. ${option_c}`}
                      {selectedOption === "d" && option_d && `D. ${option_d}`}
                    </p>
                  ) : (
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="survey"
                        name="survey"
                        onChange={handleOptionChange}
                      >
                        <FormControlLabel
                          value="a"
                          control={<Radio />}
                          label={`A. ${option_a}`}
                        />
                        <FormControlLabel
                          value="b"
                          control={<Radio />}
                          label={`B. ${option_b}`}
                        />
                        {option_c && (
                          <FormControlLabel
                            value="c"
                            control={<Radio />}
                            label={`C. ${option_c}`}
                          />
                        )}
                        {option_d && (
                          <FormControlLabel
                            value="d"
                            control={<Radio />}
                            label={`D. ${option_d}`}
                          />
                        )}
                      </RadioGroup>
                    </FormControl>
                  )}
                </div>
              </div>
            </Stack>
          )}
          {props.showButtonT && (
            <>
              {" "}
              <hr
                style={{
                  borderColor: "rgba(0, 0, 0, 0.12)",
                  borderBottom: "0",
                  marginBottom: "1",
                  marginTop: "1",
                }}
              ></hr>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifySelf="flex-start"
              >
                <PostTranslate active={translatedLang} onClick={handleClick} />
              </Stack>
            </>
          )}
          <hr
            style={{
              borderColor: "rgba(0, 0, 0, 0.12)",
              borderBottom: "0",
              marginBottom: "0",
            }}
          ></hr>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          // style={{ marginLeft: "-10px" }}
          >
            <Grid item>
              <Grid container direction="row" alignItems="center" spacing={1}>
                {ack_req !== "Y" && (
                  <Grid item>
                    <IconButton
                      onClick={() => toggleLike(islike, post_receiver_id)}
                      color={islike === "L" ? "primary" : "default"}
                      size="small"
                    //sx={{ ml: -1 }}
                    >
                      {islike === "L" ? <ThumbUpIcon /> : <ThumbUpOutlinedIcon />}
                      <Typography sx={{ ml: 0.5, fontSize: '0.85rem' }}>
                        {islike === "L" ? "Liked" : "Like"}
                      </Typography>
                    </IconButton>
                  </Grid>
                )}


              </Grid>
            </Grid>
            {ack_req === "Y" && (
              <Grid>
                <IconButton
                  //style={{ marginLeft: "-11px" }}
                  onClick={() =>
                    toggleAcknowledgment(acknowledged, post_receiver_id)
                  }
                  color={acknowledged === "Y" ? "primary" : "default"}
                >
                  {acknowledged === "Y" ? (
                    <HandshakeIcon />
                  ) : (
                    <HandshakeOutlinedIcon />
                  )}
                  <Typography style={{ marginLeft: "5px" }}>
                    {acknowledged === "Y" ? "Acknowledged" : "Acknowledge"}
                  </Typography>
                </IconButton>
              </Grid>
            )}
            {post_flag !== "" && displaybutton && (
              <Grid>
                <IconButton
                  onClick={() => toggleStarred(isstar, post_receiver_id)}
                  color={isstar === "S" ? "primary" : "default"}
                >
                  {isstar === "S" ? <Star /> : <StarBorder />}
                  <Typography style={{ marginLeft: "5px" }}>
                    {isstar === "S" ? "Starred" : "Star"}
                  </Typography>
                </IconButton>
              </Grid>
            )}
          </Grid>
        </div>
      </Stack >
    </Grid >
  );
};

export default PostItem;
